import { setUserLocale } from '$lib/stores/app/actions.js';
import { PAGES } from '$lib/utils/constants.js';
import { openModal } from 'svelte-modals';
import ModalDNSMI from '$lib/components/modals/ModalDNSMI.svelte';

/**
 * @type {import('./index.js').HomePageConfiguration}
 */
const config = {
	homeHeaderContent: {
		loginBtnTxt: 'Log In',
		logoutBtnTxt: 'Log Out',
		signUpBtnTxt: 'Sign Up',
		logoSubHeader: 'For Kids 2-8'
	},
	heroSectionContent: {
		title: `Your Child's<br/><span class="text-[2.52rem] sm:text-[4.8rem] font-extrabold">Path to Success</span><br/>Starts Here`,
		subTitle: 'Learn anywhere. Cancel anytime.',
		cta: 'Try FREE for 30 Days!',
		subTitleDisclaimer: `Then just $14.99/mo. until canceled`,
		offerBadgeImgSrc: '/assets-mkt/routes/home/gradient_da_badge_v3.svg',
		offerBadgeImgAltTxt:
			'Click to Learn about our Special Annual Offer. Get up to 70% off our monthly pricing! $45.00 per year until canceled'
	},
	homeDividerSmContent: {
		subjectListItems: ['Reading', 'Math', 'Science', 'Art & Colors', 'Music']
	},
	learningPathSectionContent: {
		superHeroImgSrc: '/assets-mkt/routes/home/superheros_v1.png',
		superHeroImgAltTxt: '3 superheros',
		titleOne: 'Learn More',
		titleTwo: 'About ABCmouse!',
		videoSrc: '/assets-mkt/routes/home/wia_2020_cc_siteencode_v2.mp4',
		videoThumbnailImgSrc: '/assets-mkt/routes/home/learn_more_thumbnail_v1.png',
		videoThumbnailAltTxt: 'A girl playing abcmouse on a computer with her dad.',
		learningPathStarImgSrc: '/assets-mkt/routes/home/star_dotted_icon_v1.svg',
		learningPathStarAltTxt: 'Star and the end of a path',
		learningPathTitle: 'Step-by-Step<br/>Learning Path',
		learningPathExplainer: `Unlock your child's learning potential with the Step-by-Step Learning Path! Dive into the complete ABCmouse curriculum, featuring over <span class="font-bold">850 exciting lessions</span> across <span class="font-bold">10 levels</span>. Watch your child advance while being motivated every step of the way by our fun Tickets and Rewards System!`,
		learningPathImgs: [
			{
				media: '(min-width: 640px)',
				src: '/assets-mkt/routes/home/learning_path_v1_2x.png',
				alt: `Abc Mouse in a school bus traveling down the learning path.`
			},
			{
				media: '',
				src: '/assets-mkt/routes/home/learning_path_v1_1x.png',
				alt: `Abc Mouse in a school bus traveling down the learning path.`
			}
		],
		learningPathImgSrc: '/assets-mkt/routes/home/learning_path_v1_1x.png',
		learningPathImgAltTxt: 'Abc Mouse in a school bus traveling down the learning path.',
		quotationMarksImgSrc: '/assets-mkt/routes/home/blue_quotes_v1.svg',
		quotationMarksAltTxt: 'Quotation marks',
		testimonials: [
			{
				title: 'ABCmouse is amazing!!',
				content: `My children are excited to learn and they don't want to stop. I'm so glad that I made the decision to invest in my children's education by signing up with ABCmouse. Thank you! I'm a happy mother!`,
				credit: '--Mother of 3 - and 5-year-old girls'
			},
			{
				title: 'My son loves ABCmouse!',
				content: `ABCmouse has a huge variety of learning activities to keep my child interested. What a brilliant idea to include such a fun reward system. I don't know who loves ABCmouse more . . . me or him!`,
				credit: '—Mother of 3-year-old boy'
			}
		]
	},
	homeDividerLgContent: {
		images: [
			{
				media: '(min-width: 1200px)',
				src: '/assets-mkt/routes/home/awards_v5.svg',
				alt: `Mom's Choice Gold Award Teacher's Choice Gold Award Parent's Choice Gold Award America's Most Downloaded Kids' Education App of All Time`
			},
			{
				media: '',
				src: '/assets-mkt/routes/home/awards_v5_1x.svg',
				alt: `Mom's Choice Gold Award Teacher's Choice Gold Award Parent's Choice Gold Award America's Most Downloaded Kids' Education App of All Time`
			}
		]
	},
	subjectsSectionContent: {
		subjectsIconImgSrc: '/assets-mkt/routes/home/pencil_icon_v1.svg',
		subjectsIconImgAltTxt: 'Pencil icon',
		subjectsSectionTitle: 'Subjects',
		subjects: [
			{
				imgSrc: '/assets-mkt/routes/home/cat_v2.png',
				imgSrcAltTxt: 'cat on a skateboard',
				title: 'Reading and Language Arts',
				content: `ABCmouse's reading curriculum spans the entire range of early reading and includes phonics, letter recognition, parts of speech, and more.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/abc_math_v1.png',
				imgSrcAltTxt: 'ABC mouse doing math',
				title: 'Numbers and Math',
				content: `ABCmouse teaches numbers, addition and subtraction, shapes, patterns, measurements, and more through fun games and creative activities.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/ivan_v1.png',
				imgSrcAltTxt: 'scientist',
				title: 'The World Around Us',
				content: `ABCmouse's science and social studies curriculum helps children understand the world they live in and inspires curiosity.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/brushly_v1.png',
				imgSrcAltTxt: 'art brush',
				title: 'Arts and Colors',
				content: `ABCmouse's drawing and painting program gives children the opportunity to use lines, shapes, and colors to create original works of art.`
			}
		]
	},
	homeschoolSectionContent: {
		homeschoolIconImgSrc: '/assets-mkt/routes/home/award_icon_v1.svg',
		homeschoolIconImgAltTxt: 'Award icon',
		homeschoolSectionTitleOne: 'Award-Winning',
		homeschoolSectionTitleTwo: 'Homeschool Resources',
		homeschoolSubTitle: 'One of the Best Homeschooling Resources for Your Child!',
		homeschoolContentOne: `ABCmouse's high-quality curriculum has thousands of learning activities to support your child's education at home!`,
		homeschoolContentTwo: `Backed by research and designed in collaboration with nationally recognized childhood education experts, ABCmouse's supplemental homeschool curriculum includes:`,
		curriculumListItems: [
			{
				imgSrc: '/assets-mkt/routes/home/homeschool_book_dt_v3_5x.png',
				imgSrcAltTxt: 'books',
				title: 'Books'
			},
			{
				imgSrc: '/assets-mkt/routes/home/homeschool_game_dt_v2_5x.png',
				imgSrcAltTxt: 'games',
				title: 'Games'
			},
			{
				imgSrc: '/assets-mkt/routes/home/homeschool_learning_video_dt_v2_5x.png',
				imgSrcAltTxt: 'learning videos',
				title: 'Learning Videos'
			},
			{
				imgSrc: '/assets-mkt/routes/home/homeschool_puzzle_dt_v2_5x.png',
				imgSrcAltTxt: 'puzzles',
				title: 'Puzzles'
			},
			{
				imgSrc: '/assets-mkt/routes/home/homeschool_more_dt_v2_5x.png',
				imgSrcAltTxt: 'and more!',
				title: 'And More!'
			}
		]
	},
	activitiesSectionContent: {
		activitiesIconImgSrc: '/assets-mkt/routes/home/paint_icon_v1.svg',
		activitiesIconImgAltTxt: 'Award icon',
		activitiesSectionTitle: 'Activities',
		activities: [
			{
				imgSrc: '/assets-mkt/routes/home/animation_v1.png',
				imgSrcAltTxt: 'animation',
				title: 'Animation',
				content: `ABCmouse's curriculum includes hundreds of highly entertaining animated activities, each teaching a specific learning topic. From Prospector Paul discovering new letter combinations, to King Grammar explaining proper nouns to his villagers, these animated videos engage children while they learn.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/games_v1.png',
				imgSrcAltTxt: 'games',
				title: 'Games',
				content: `ABCmouse features hundreds of fun and interactive games, each designed to teach a specific educational concept. Your child can play to learn the alphabet, encounter new words, practice numbers and shapes, and even learn about the planets! Since all of the games on the site include voiced instructions, they are easy for even young children to understand and enjoy.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/books_v1.png',
				imgSrcAltTxt: 'books',
				title: 'Books',
				content: `With more than 450 traditional and original stories and nonfiction books, ABCmouse's library opens a door to worlds of knowledge, adventure, and fun for children. Every topic of our curriculum—whether it is the sound of a letter, counting 1-100, the four seasons in the year, or regions of the United States—is explained in child-friendly language in one of our library books.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/songs_v1.png',
				imgSrcAltTxt: 'songs',
				title: 'Songs',
				content: `ABCmouse's music collection features original songs about every letter of the alphabet and many other topics of our curriculum, as well as newly produced and recorded children's classics. The variety of music on our site not only reinforces the other subjects but also introduces children to a range of musical styles and themes. Your child will love to sing along!`
			},
			{
				imgSrc: '/assets-mkt/routes/home/puzzles_v1.png',
				imgSrcAltTxt: 'puzzles',
				title: 'Puzzles',
				content: `Find hundreds of jigsaw and cutout puzzles designed to help develop problem solving and critical thinking skills. Puzzles also help children remember important ideas and skills in reading, math, science, art, social studies, and music. There are puzzles for every letter of the alphabet, sight words, stories, numbers, shapes, animals, the base-ten number system, elements of fiction stories, and many, many other topics.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/art_v1.png',
				imgSrcAltTxt: 'art',
				title: 'Art',
				content: `With many different types of art activities—including coloring pages, dot-to-dots, paint-by-numbers, traceables, and printables—ABCmouse helps children learn reading, math, and other subjects while they are expressing themselves artistically.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/printables_v1.png',
				imgSrcAltTxt: 'printables',
				title: 'Printables',
				content: `ABCmouse has more than 2,000 printable activities across reading, math, art and colors, and more. We encourage children to continue their learning offline with printable activities that include letter and number tracing, coloring, dot-to-dot pictures, paint-by-number drawings, mazes, and pattern recognition activities.`
			}
		]
	},
	featuresSectionContent: {
		featuresIconImgSrc: '/assets-mkt/routes/home/bus_icon_v1.svg',
		featuresIconImgAltTxt: 'School bus icon',
		featuresSectionTitle: 'More Features',
		features: [
			{
				imgSrc: '/assets-mkt/routes/home/progress_v1.png',
				imgSrcAltTxt: 'progress',
				title: 'Progress Tracking',
				content: `It's easy to see how much progress your child is making with the ABCmouse Progress Tracker. In addition to the display of total number of learning activities completed in each category (books, songs, puzzles, games, and art), there are easy-to-read graphs that show progress both by academic level and by curriculum subject.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/tickets_v1.png',
				imgSrcAltTxt: 'tickets',
				title: 'Tickets and Rewards',
				content: `ABCmouse encourages children to complete learning activities by rewarding them with tickets. Tickets can be used to “purchase” virtual items on the site, such as new fish for the classroom. The Tickets and Rewards System makes learning a game, and also teaches important math skills as children keep track of tickets earned and spent.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/avatar_v1.png',
				imgSrcAltTxt: 'avatar',
				title: 'Customizable Avatar',
				content: `The avatar is a character that your child can choose to represent him or herself while on ABCmouse. There's a broad choice of avatar features and clothing, and other avatar-related items that can be purchased with tickets. `
			},
			{
				imgSrc: '/assets-mkt/routes/home/zoo_v1.png',
				imgSrcAltTxt: 'zoo',
				title: 'Interactive Zoo',
				content: `ABCmouse's zoo allows children to interact with realistic zoo animals, including elephants, lions, monkeys, zebras, penguins, and more! Learn facts about each animal and read books, play games, and do puzzles and art activities for each one.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/aquarium_v1.png',
				imgSrcAltTxt: 'aquarium',
				title: 'Aquarium',
				content: `Your child can choose exotic tropical fish and other items to put in the Classroom Aquarium and learn lots of interesting fish facts at the same time.`
			},
			{
				imgSrc: '/assets-mkt/routes/home/farm_v1.png',
				imgSrcAltTxt: 'farm',
				title: 'Interactive Farm',
				content: `ABCmouse's interactive farm features horses, chickens, cows, and more! Watch beautiful animations of our farm animals, learn fun and interesting facts about each one, and do farm-related activities! `
			}
		]
	},
	prospectRegisterContent: {
		title: 'Try It Free',
		subtitle: 'FOR 30 DAYS',
		disclaimer: 'Then $14.99/mo. until canceled',
		placeholder: 'Email Address',
		errorMessage: 'Please enter an email address',
		agreeText: 'I agree to receive emails from ABCmouse.',
		agreeError: 'You must agree to receive emails from ABCmouse.com.',
		privacyLink: {
			text: 'Privacy Policy',
			url: PAGES.EXTERNAL.PRIVACY_POLICY,
			alt: 'Privacy Policy'
		},
		buttonText: 'Continue'
	},
	homeFooterContent: {
		ratingsImage: '/assets-mkt/routes/home/rating.png',
		ratingsAlt: '500k+ Parents rate ABCmouse 5-stars',
		socialHeader: 'Follow Us',
		socials: [
			{
				src: `/assets-mkt/routes/home/tiktok_icon_v1.svg`,
				alt: 'tiktok-link',
				href: PAGES.EXTERNAL.TIKTOK
			},
			{
				src: `/assets-mkt/routes/home/fb_icon_v1.svg`,
				alt: 'facebook-link',
				href: PAGES.EXTERNAL.FACEBOOK
			},
			{
				src: `/assets-mkt/routes/home/insta_icon_v1.svg`,
				alt: 'insta-link',
				href: PAGES.EXTERNAL.INSTAGRAM
			},
			{
				src: `/assets-mkt/routes/home/pinterest_icon_v1.svg`,
				alt: 'pinterest-link',
				href: PAGES.EXTERNAL.PINTEREST
			}
		],
		popularResourcesLinks: [
			{
				id: 'about-us',
				text: 'About Us',
				href: PAGES.EXTERNAL.AOFL,
				aria: 'Learn about Age of Learning and all our Award-Winning Products.',
				target: '_blank'
			},
			{
				id: 'careers',
				text: 'Careers',
				href: PAGES.EXTERNAL.CAREERS,
				aria: 'Careers',
				target: '_blank'
			},
			{
				id: 'media-center',
				text: 'Press',
				href: PAGES.EXTERNAL.MEDIA,
				aria: 'Press',
				target: '_blank'
			},
			{
				id: 'faqs',
				text: 'FAQs',
				href: PAGES.INTERNAL.LEGACY.FAQS,
				aria: 'FAQs',
				target: ''
			},
			{
				id: 'customer-support',
				text: 'Customer Care',
				href: PAGES.INTERNAL.LEGACY.CUSTOMER_SUPPORT,
				aria: 'Customer Care',
				target: ''
			},
			{
				id: 'gift-cards',
				text: 'Redeem',
				href: PAGES.INTERNAL.REDEEM,
				aria: 'Redeem a code or Purchase an Instant Online Gift Code',
				target: ''
			},
			{
				id: 'give-a-gift',
				text: 'Give a Gift',
				href: PAGES.INTERNAL.GIVE_A_GIFT,
				aria: 'Give a Gift',
				target: ''
			}
		],
		moreAbcmouseLinks: [
			{
				id: 'schools',
				text: 'Schools',
				href: PAGES.EXTERNAL.AOFL_FOR_SCHOOLS,
				aria: 'ABCmouse for Schools',
				target: '_blank'
			},
			{
				id: 'libraries',
				text: 'Libraries',
				href: PAGES.INTERNAL.LEGACY.LIBRARIES,
				aria: 'ABCmouse for Libraries',
				target: '_blank'
			},
			{
				id: 'teachers',
				text: 'Teachers',
				href: PAGES.INTERNAL.LEGACY.TEACHERS,
				aria: 'ABCmouse for Teachers',
				target: '_blank'
			},
			{
				id: 'en-espanol',
				text: 'En español',
				type: 'callback',
				href: '',
				callback: () => setUserLocale('es-US'),
				aria: 'ABCmouse in Spanish',
				target: '_blank'
			},
			{
				id: 'learning',
				text: 'Learning',
				href: PAGES.EXTERNAL.LEARN,
				aria: 'ABCmouse Learning',
				target: '_blank'
			},
			{
				id: 'games',
				text: 'Games',
				href: PAGES.EXTERNAL.ABCMOUSE_SEO_GAMES_PAGE,
				aria: 'ABCmouse Games',
				target: '_blank'
			},
			{
				id: 'activities',
				text: 'Activities',
				href: PAGES.EXTERNAL.ACTIVITIES,
				aria: 'ABCmouse Activities',
				target: '_blank'
			},
			{
				id: 'printables',
				text: 'Printables',
				href: PAGES.EXTERNAL.PRINTABLES,
				aria: 'ABCmouse Printables',
				target: '_blank'
			}
		]
	},
	primaryFooterContent: {
		links: [
			{
				id: 'trade-mark',
				text: `TM & © 2007-${new Date().getFullYear()} Age of Learning, Inc. All rights reserved.<br />`,
				href: PAGES.EXTERNAL.AOFL,
				aria: 'Age of Learning Inc. Copyright Notice',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'terms-conditions',
				text: 'Terms & Conditions',
				href: PAGES.EXTERNAL.TERMS_CONDITIONS,
				aria: 'Terms and Conditions',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'privacy-policy',
				text: 'Privacy Policy',
				href: PAGES.EXTERNAL.PRIVACY_POLICY,
				aria: 'Privacy Policy',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'do-not-sell',
				text: 'Do Not Sell My Personal&nbsp;Information',
				href: '#do-not-sell',
				aria: 'Do Not Sell My Personal Information',
				type: 'callback',
				callback: () =>
					openModal(ModalDNSMI, {
						modalImageSrc: '/assets-mkt/template/cookie-consent-modal/abc_logo-v1.png'
					})
			},
			{
				id: 'customer-support',
				text: 'Customer Care',
				href: PAGES.EXTERNAL.CUSTOMER_SUPPORT,
				aria: 'Customer Care Support',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'accessibility',
				text: 'Accessibility&nbsp;Statement',
				href: PAGES.EXTERNAL.ACCESSIBILITY,
				aria: 'Accessibility Statement',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'give-a-gift',
				text: 'Give&nbsp;a&nbsp;Gift',
				href: PAGES.INTERNAL.GIVE_A_GIFT,
				aria: 'Give a Gift',
				target: ''
			}
		]
	}
};

export default config;
